import React, {
  Fragment,
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react'

//importing components
import Control from 'components/Control/Control'
import Divider from 'components/Divider/Divider'
import Label from 'components/Label/Label'
import FileReader from 'components/Uploader/FileReader'
import Uploadloader from 'components/Uploader/Uploader'
import CustomTag from 'components/CustomTag'

import { CloseCircleOutlined, ExclamationCircleFilled } from '@ant-design/icons'
import { Alert, Empty, Spin } from 'antd'
import AntdInput from 'components/Form/Input'
import AntdSelect from 'components/Form/Select'
import AddIcon from 'components/icons/AddIcon'
import Delete from 'components/icons/Delete'
import Dropdown from 'components/icons/Dropdown'
import PercentIcon from 'components/icons/PercentIcon'
import styled from 'styled-components'

const PendingIcon = styled(ExclamationCircleFilled)`
  color: #eb5d60;
  font-size: 16px;
  margin-left: 8px;
`
import {
  MonthList,
  boardList,
} from 'modules/Onboarding/Register/Education/constant'
import {
  AdjustIcon,
  ButtonLocal,
  Container,
  CurrentText,
  CurrentWrapper,
  FormItem,
  Heading,
  IconView,
  InputWrapper,
  LabelWrapper,
  MarksFlex,
  SpinWrapper,
  SubHeading,
  StyledFormItem,
  CurrentCourseWrapper
} from 'modules/Onboarding/Register/EducationNew/style'
import WorkExpAwardForm from 'modules/Resume/DrawerComponents/ProjectDetails/WorkExpAwardForm'
import { Text } from 'modules/Resume/DrawerComponents/ProjectDetails/style'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { searchConfig } from 'utils/config'
import { validateNumber } from 'utils/decimalValidation'
import { debounce, getValuebyName } from '../../../../utils/helpers'
import { RedNote } from '../PersonalInfo/style'
import { useDispatch } from 'react-redux'
import { getEligibilityCriteria } from 'modules/Onboarding/actions'
import Date from 'components/Date/Date';
import { StyledSelectDivLeft, StyledInputDivRight } from '../PersonalInfo/style'

const initialErrorState = {
  institutionName: '',
  degree: '',
  department: '',
  specialisation: '',
  university: '',
  state: '',
  city: '',
}

const EducationForm = ({
  form,
  level,
  label,
  isType,
  onRemoveEducation,
  isCurrentCourse,
  studentFormData,
  getEducationLevel,
  educationId,
  universityValue,
  setUniversityName,
  universityList,
  stateList,
  getListOfCountries,
  getListOfState,
  getListOfCity,
  loadingCity,
  loadingState,
  setLoadingCity,
  setLoadingState,
  setStateId,
  stateId,
  cityId,
  setCityId,
  examType,
  duration,
  setExamType,
  setDuration,
  setSearchState,
  AllCollegeList,
  CollegeList,
  setInstituteCampusName,
  instituteCampusValue,
  universityId,
  setUniversityId,
  setInstituteId,
  getListOfSkills,
  setCurrentInstituteName,
  setCurrentInstituteId,
  setUniversitySearchList,
  universitySearchList,
  getEducationLevelSearch,
  setSkillLoading,
  skillLoading,
  searchAPI,
  SkillsAPI,
  allSkills,
  hasPendingChanges,
  requestId,
  pendingFields,
  frozenFields,
}) => {
  
  const hasFieldPending = (fieldName) => {
    return pendingFields && pendingFields[fieldName] !== undefined
  }

  const LabelWithPending = ({ children, fieldName, ...props }) => {
    return (
      <Label {...props}>
        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          {hasFieldPending(fieldName) && <PendingIcon />}
          {children}
        </span>
      </Label>
    )
  }
  
  const currentDate = moment()
  const [degreeSearchList, setDegreeSearchList] = useState([])
  const [listOfSkills, setListOfSkills] = useState(allSkills || [])
  const [departmentSearchList, setDepartmentSearchList] = useState([])
  const [specialisationsSearchList, setSpecialisationsSearchList] = useState([])
  const [
    specialisationsCurrentSearchList,
    setSpecialisationsCurrentSearchList,
  ] = useState([])

  const [errorNote, setErrorNote] = useState()
  const [deleted, setDeleted] = useState(false)
  const [addInstitute, setAddInstitute] = useState(false)
  const metricsData = useSelector(
    state => state?.appliedRoleData?.appliedRoleMetrics
  )
  const [boardName, setBoardName] = useState(
    form.getFieldValue([[level], 'board'])
  )
  const [show, setShow] = useState(true)
  const [endedYear, setEndedYear] = useState(
    form.getFieldValue([[level], 'endedYear'])
  )

  const [batch, setBatch] = useState('')
  const [stateError, setStateError] = useState('')
  const [cityError, setCityError] = useState('')
  const [startDate, setStartDate] = useState('')
  const [startMonth, setStartMonth] = useState('')
  const [startYear, setStartYear] = useState('')
  const [endDate, setEndDate] = useState('')
  const [endMonth, setEndMonth] = useState('')
  const [endYear, setEndYear] = useState('')
  const { DEPARTMENT_ID } = process.env

  const [markSheetFile, setMarkSheetFile] = useState(
    form.getFieldValue([[level], 'markSheetUrl'])
  )
  const getMarksheetLabel = level => {
  if (level === 'tenth') return '10th Marksheet'
  if (level === 'twelfth') return '12th Marksheet'
  if (level === 'diploma') return 'Diploma Marksheet'
  if (level === 'ug') return 'UG Marksheet'
  if (level === 'pg') return 'PG Marksheet'
  if (level === 'iscurrentcourse') return 'Upload Marksheet'
  return 'Attachments'
}

  const [tcFile, setTcFile] = useState(form.getFieldValue([[level], 'tcUrl']))

  const [showOtherInputDegree, setShowOtherInputDegree] = useState(
    form.getFieldValue([[level], 'degreeId']) === 'OTHERS'
  )
  const [showOtherInputDepartment, setShowOtherInputDepartment] = useState(
    form.getFieldValue([[level], `streamId`]) === 'OTHERS'
  )
  const [showOtherInputSpecialisation, setShowOtherInputSpecialisation] =
    useState(form.getFieldValue([[level], `specialisationId`]) === 'OTHERS')

  const [selectedSkill, setSelectedSkill] = useState([])
  const [storeSkill, setStoreSkill] = useState([])
  const [cityList, setCityList] = useState([])
  const [statesList, setStatesList] = useState([])

  const [skillErrorMsg, setSkillErrorMsg] = useState('')
  const [award, setAward] = useState([])
  const [awardList, setAwardList] = useState([])
  const [dateErrorMsg, setDateErrorMsg] = useState('')
  const [eduErrorMsg, setEduErrorMsg] = useState('')
  const currentYear = moment().year()
  const [instituteSearchList, setInstituteSearchList] = useState([])
  const [curInstituteSearchList, setCurInstituteSearchList] = useState([])
  const [loadingInstitute, setLoadingInstitute] = useState(true)
  const [showSpecialization, setShowSpecialization] = useState(false)
    const [specialisationId, setSpecialisationId] = useState(() => {
      const formValue = form.getFieldValue([[level], 'specialisationId']);
      if (!formValue) return [];
      // Convert comma-separated string to array if needed
      return typeof formValue === 'string' ? formValue.split(',').filter(Boolean) : formValue;
    })
  const [markType, setMarkType] = useState('Percentage')
  const dispatch = useDispatch()

  const markTypeList = [
    {
      id: 'Percentage',
      value: 'Percentage',
    },
    {
      id: 'CGPA',
      value: 'CGPA',
    },
  
  ]
  const completeCrudDegreeList = [
    ...degreeSearchList,
    { name: 'Other', id: 'OTHERS' },
  ]

  const completeCrudDepartmentList = [
    ...departmentSearchList,
    { name: 'Other', id: 'OTHERS' },
  ]

  // const completeCrudSpecialisationList = [
  //   ...specialisationsSearchList,
  //   { name: 'Other', id: 'OTHERS' },
  // ]

  const onMarkTypeChange = (value) => {
    setMarkType(value)
    form.setFieldsValue({
      [level]: {
        marks: '',
        cgpaValue: '',
        cgpaOutof: '',
      },
    })
  }


  const recalculateMarks = () => {
    if (markType === 'CGPA') {
      const cgpaValue = Number(form.getFieldValue([level, 'cgpaValue']))
      const cgpaOutof = Number(form.getFieldValue([level, 'cgpaOutof']))
      if (cgpaValue && cgpaOutof && cgpaOutof > 0) {
        const percentage = ((cgpaValue / cgpaOutof) * 100).toFixed(2)
        form.setFieldsValue({ [level]: { marks: percentage } })
      } else {
        form.setFieldsValue({ [level]: { marks: '' } })
      }
    }
  }

    useEffect(() => {
    recalculateMarks()
  }, [form.getFieldValue([level, 'cgpaValue']), form.getFieldValue([level, 'cgpaOutof'])])
  const fetchInstitutList = async () => {
    let campusName = form.getFieldValue([
      [level],
      isCurrentCourse ? 'collegeName' : 'institutionName',
    ])
    let campusId = form.getFieldValue([
      [level],
      isCurrentCourse ? 'collegeId' : 'institutionId',
    ])

    let state = form.getFieldValue([[level], 'state'])
    let city = form.getFieldValue([[level], 'city'])
    let stateId = form.getFieldValue([[level], 'stateId'])
    let cityId = form.getFieldValue([[level], 'cityId'])
    const results = await instituteSearching(campusName, state, city)
    if (!campusId && campusName) {
      form.setFieldValue(
        [[level], isCurrentCourse ? 'collegeName' : 'institutionName'],
        ''
      )

      if (results?.length) {
        let campusObj = results[0]
        if (
          campusObj?.campusName?.toLowerCase() == campusName.toLowerCase() ||
          results?.length == 1
        ) {
          form.setFieldValue(
            [[level], isCurrentCourse ? 'collegeName' : 'institutionName'],
            campusObj?.campusName
          )

          form.setFieldValue(
            [[level], isCurrentCourse ? 'collegeId' : 'institutionId'],
            campusObj?.instituteId
          )

          if ((!cityId && !city) || (!stateId && !state)) {
            if (campusObj) {
              let state = form.setFieldValue(
                [[level], 'state'],
                campusObj?.state
              )
              let city = form.setFieldValue([[level], 'city'], campusObj?.city)
              fetchStateCity(state, city)
            }
          }
        } else {
          setErrorNote(prevError => ({
            ...prevError,
            institutionName: results?.length
              ? `Searched results for : ${campusName}`
              : `No data matched for : ${campusName}`,
          }))

          if (!results?.length) instituteSearching('', state, city)
          form.setFieldValue(
            [[level], isCurrentCourse ? 'collegeName' : 'institutionName'],
            ''
          )
        }
      } else {
        setErrorNote(prevError => ({
          ...prevError,
          institutionName: results?.length
            ? `Searched results for : ${campusName}`
            : `No data matched for : ${campusName}`,
        }))

        if (!results?.length) instituteSearching('', state, city)
        form.setFieldValue(
          [[level], isCurrentCourse ? 'collegeName' : 'institutionName'],
          ''
        )
      }
    } else if (campusId && campusName) {
      for (let campus of results) {
        if (campus.id == campusId) {
          if ((!cityId && !city) || (!stateId && !state)) {
            if (campus) {
              let state = form.setFieldValue([[level], 'state'], campus?.state)
              let city = form.setFieldValue([[level], 'city'], campus?.city)
              fetchStateCity(state, city)
            }
          }
          break
        }
      }
      instituteSearching('', state, city)
    } else if (campusName) {
      setErrorNote(prevError => ({
        ...prevError,
        institutionName: results?.length
          ? `Searched results for : ${campusName}`
          : `No data matched for : ${campusName}`,
      }))

      if (!results?.length) instituteSearching('', state, city)
      form.setFieldValue(
        [[level], isCurrentCourse ? 'collegeName' : 'institutionName'],
        ''
      )
    }
  }

  const degreeSearching = async (degree = '') => {
    let filters = [...(searchConfig?.degrees?.filters || [])]
    if (level) {
      filters?.push({
        field: 'type.keyword',
        value: getEducationLevelSearch(level?.toLowerCase()),
      })
    }

    const degreeResult = await searchAPI(searchConfig?.degrees?.name, degree, {
      ...searchConfig?.degrees,
      filters,
    })
      .then(results => {
        setDegreeSearchList(results)
        return results
      })
      .catch(error => {
        console.error(`Error searching ${searchConfig?.degrees?.name}:`, error)
        return []
      })
    return degreeResult || []
  }

  const years = []
  for (let year = currentYear; year >= 1923; year--) {
    years.push({
      value: year,
      name: year,
    })
  }
  const endYears = []
  for (let year = 2033; year >= startYear; year--) {
    endYears.push({
      value: year,
      name: year,
    })
  }

  const eduValidatorSchool = (rule, value) => {
    const endDate = moment(
      `${form.getFieldValue([[level], 'endYear'])}-${form.getFieldValue([
        [level],
        'endMonth',
      ])}-01`
    )
    const isEndMonthInList =
      MonthList.find(
        item => item.value == form.getFieldValue([[level], 'endMonth'])
      ) !== undefined
    const isEndYearInList =
      years.find(
        item => item.value == form.getFieldValue([[level], 'endYear'])
      ) !== undefined
    const now = moment()

    if (
      form.getFieldValue([[level], 'endMonth']) === undefined &&
      isEndYearInList
    ) {
      setEduErrorMsg(' Please select Month')
      form.setFieldsValue({ [level]: { error: 'Please select Month' } })
      return Promise.reject(new Error(''))
    }

    if (
      form.getFieldValue([[level], 'endYear']) === undefined &&
      isEndMonthInList
    ) {
      setEduErrorMsg(' Please select Year')
      form.setFieldsValue({ [level]: { error: 'Please select Year' } })
      return Promise.reject(new Error(''))
    }

    if (endDate > now) {
      setEduErrorMsg('Date cannot be in the future')
      form.setFieldsValue({
        [level]: { error: 'Date cannot be in the future' },
      })
      return Promise.reject(new Error(''))
    } else {
      setEduErrorMsg('')
      return Promise.resolve()
    }
  }

  useEffect(() => {
    eduValidatorSchool()
  }, [endMonth, endYear])

  // useEffect(() => {
  //   if (instituteSearchList.length) {
  //     setInstituteSearchList([
  //       {
  //         campusName: 'Other',
  //         id: 'OTHER',
  //         isActive: 'true',
  //       },
  //       ...instituteSearchList,
  //     ])
  //   }
  // }, [instituteSearchList])

  const Yearvalidator = (rule, value) => {
    const startDate = moment(
      `${form.getFieldValue([[level], 'startYear'])}-${form.getFieldValue([
        [level],
        'startMonth',
      ])}-01`
    )
    const endDate = moment(
      `${form.getFieldValue([[level], 'endYear'])}-${form.getFieldValue([
        [level],
        'endMonth',
      ])}-01`
    )
    const now = moment()

    if (form.getFieldValue([[level], 'startMonth']) === undefined) {
      // setDateErrorMsg(' Please select StartMonth')
      form.setFieldsValue({ [level]: { error: 'Please select StartMonth' } })
      return Promise.reject(new Error(''))
    } else if (form.getFieldValue([[level], 'startYear']) === undefined) {
      // setDateErrorMsg(' Please select StartYear')
      form.setFieldsValue({ [level]: { error: 'Please select StartYear' } })
      return Promise.reject(new Error(''))
    } else if (startDate > now) {
      setDateErrorMsg(' Start Date cannot be in the future')
      form.setFieldsValue({
        [level]: { error: 'Start Date cannot be in the future' },
      })
      return Promise.reject(new Error(''))
    } else if (form.getFieldValue([[level], 'endMonth']) === undefined) {
      // setDateErrorMsg(' Please select EndMonth')
      form.setFieldsValue({ [level]: { error: 'Please select EndMonth' } })
      return Promise.reject(new Error(''))
    } else if (form.getFieldValue([[level], 'endYear']) === undefined) {
      // setDateErrorMsg(' Please select EndYear')
      form.setFieldsValue({ [level]: { error: 'Please select EndYear' } })
      return Promise.reject(new Error(''))
    } else if (endDate < startDate) {
      setDateErrorMsg('End date cannot be before start date')
      form.setFieldsValue({
        [level]: { error: 'End date cannot be before start date' },
      })
      return Promise.reject(new Error(''))
    } else if (startDate?._i === endDate?._i) {
      setDateErrorMsg('End date cannot be same as start date')
      form.setFieldsValue({
        [level]: { error: 'End date cannot be same as start date' },
      })
      return Promise.reject(new Error(''))
    } else {
      setDateErrorMsg('')
      return Promise.resolve()
    }
  }

  const fetchSpecialisation = async (
    searchValue = '',
    degreeId = '',
    departmentId = ''
  ) => {
    if (degreeId && departmentId) {
      const response = await dispatch(
        getEligibilityCriteria({
          searchValue: searchValue?.trim(),
          searchType: 'SPECIALISATION',
          searchField: [],
          degreeId: degreeId,
          departmentId: departmentId,
        })
      )

      if (response?.[0]?.streams?.[0]?.specialisations) {
        const specialisations =
          response?.[0]?.streams?.[0]?.specialisations?.map(course => ({
            name: course?.specialisationName,
            id: course?.specialisationId,
            status: course?.specialisationStatus,
          }))
        setSpecialisationsCurrentSearchList(specialisations || [])
        if (specialisations?.length > 0 && !showSpecialization) {
          setShowSpecialization(true)
        } else {
          setSpecialisationsCurrentSearchList([])
        }
      }
    } else {
      setSpecialisationsCurrentSearchList([])
    }
  }

  useEffect(() => {
    if (
      form.getFieldValue([[level], 'degreeId']) &&
      form.getFieldValue([[level], 'streamId']) &&
      isCurrentCourse
    ) {
      fetchSpecialisation(
        '',
        form.getFieldValue([[level], 'degreeId']),
        form.getFieldValue([[level], 'streamId'])
      )
    }
    if (
      form.getFieldValue('specialisation') !== null &&
      form.getFieldValue('specialisation') !== undefined &&
      form.getFieldValue('specialisation') !== ''
    ) {
      setShowSpecialization(true)
    }
  }, [isCurrentCourse, form.getFieldValue([[level], 'streamId'])])

  useLayoutEffect(() => {
    form.setFieldValue([[level], 'shown'], true)
    setAwardList(form.getFieldValue([[level], 'awards']))
    if (!isType) {
      updateUniversityData()
      updateDegreeData()
      updateDepartmentData()
      updateSpecialisationData()
      fetchInstitutList()
      fetchInitialData()
    } else {
      getStateData()
    }
  }, [])

  useLayoutEffect(() => {
    updateSkillsData()
  }, [listOfSkills])

  useLayoutEffect(() => {
    let listData = []
    if (awardList !== undefined) {
      awardList.forEach((data, index) => {
        let formName1 = level + 'award+' + index
        const formattedDescription = Array.isArray(data?.description)
          ? data.description.map(item => `${item}`).join('\n')
          : data?.description
        form.setFieldsValue({
          [formName1]: {
            title: data?.title,
            awarded_on: data?.awarded_on,
            description: formattedDescription,
            certificate: data?.certificate?.size ? data?.certificate : {},
          },
        })
        listData.push({
          component: WorkExpAwardForm,
          formName: formName1,
        })
      })

      setAward(listData)
    }
  }, [awardList])

  useLayoutEffect(() => {
    if (
      form.getFieldValue([[level], 'startedOn']) != undefined ||
      form.getFieldValue([[level], 'startedOn']) != null
    ) {
      const dateParts = form.getFieldValue([[level], 'startedOn'])?.split('/')
      setStartMonth(dateParts?.[0])
      setStartYear(dateParts?.[1])
      form.setFieldsValue({ [level]: { startMonth: dateParts?.[0] } })
      form.setFieldsValue({ [level]: { startYear: dateParts?.[1] } })
      setStartDate(moment(form.getFieldValue([[level], 'startedOn'])))
    }
    if (
      form.getFieldValue([[level], 'endedOn']) != undefined ||
      form.getFieldValue([[level], 'endedOn']) != null
    ) {
      const dateParts = form.getFieldValue([[level], 'endedOn'])?.split('/')
      setEndMonth(dateParts?.[0])
      setEndYear(dateParts?.[1])
      form.setFieldsValue({ [level]: { endMonth: dateParts?.[0] } })
      form.setFieldsValue({ [level]: { endYear: dateParts?.[1] } })
      setEndDate(moment(form.getFieldValue([[level], 'endedOn'])))
    }
  }, [])
  const onBlurInstituteNmae = e => {
    form.setFieldsValue({
      [level]: { institutionName: e.target.value },
    })
  }

  const onBoardChange = data => {
    form.setFieldsValue({ [level]: { board: data } })
    setBoardName(data)
  }
  const onDateChange = (date, dateString) => {
    form.setFieldsValue({ [level]: { endedYear: dateString } })
    setEndedYear(dateString)
  }

  const onDegreeChangeDrop = (data, option) => {
    if (isCurrentCourse && data && option && data !== 'OTHERS') {
      form.setFieldsValue({
        [level]: {
          educationLevel: getEducationLevel(
            option?.option?.type?.toLowerCase()
          ),
        },
      })
    }
    setErrorNote(prevError => ({
      ...prevError,
      degree: '',
    }))
    if (data === 'OTHERS') {
      setShowOtherInputDegree(true)
      degreeSearching('')
      let otherDegree = form.getFieldValue([[level], 'otherDegree'])?.trim('')

      form.setFieldsValue({ [level]: { department: '' } })
      form.setFieldsValue({ [level]: { specialisation: '' } })
      form.setFieldsValue({ [level]: { degree: otherDegree } })
      form.setFieldsValue({ [level]: { degreeId: option?.option?.id } })
      form.setFieldsValue({ [level]: { streamId: '' } })
      form.setFieldsValue({ [level]: { specialisationId: '' } })
      setSpecialisationId([])
      form.setFieldsValue({
        [level]: {
          educationLevel: getEducationLevel(level?.toLowerCase()),
        },
      })
    } else {
      setShowOtherInputDegree(false)
      degreeSearching('')

      form.setFieldsValue({ [level]: { department: '' } })
      form.setFieldsValue({ [level]: { specialisation: '' } })
      form.setFieldsValue({ [level]: { degree: option?.option?.name } })
      form.setFieldsValue({ [level]: { degreeId: option?.option?.id } })
      form.setFieldsValue({ [level]: { streamId: '' } })
      form.setFieldsValue({ [level]: { specialisationId: '' } })
      form.setFieldsValue({ [level]: { domain: option?.option?.domainName } })
      form.setFieldsValue({ [level]: { domainId: option?.option?.domainId } })
      if(option?.option?.name?.toLowerCase() === 'master of business administration' || option?.option?.name?.toLowerCase() === 'post graduate diploma in management'){
        form.setFieldsValue({ [level]: { department: 'Management' } })
        form.setFieldsValue({ [level]: { streamId: DEPARTMENT_ID } })
      }
      setSpecialisationId([])
    }
  }
  const onDepartmentChangeDrop = (data, option) => {
    setErrorNote(prevError => ({
      ...prevError,
      department: '',
    }))
    if (data === 'OTHERS') {
      setShowOtherInputDepartment(true)
      departmentSearching('')
      let otherDepartment = form
        .getFieldValue([[level], 'otherDepartment'])
        ?.trim('')

      form.setFieldsValue({ [level]: { specialisation: '' } })
      form.setFieldsValue({ [level]: { department: otherDepartment } })
      form.setFieldsValue({ [level]: { streamId: option?.option?.id } })
      form.setFieldsValue({ [level]: { specialisationId: '' } })
      setSpecialisationId([])
    } else {
      setShowOtherInputDepartment(false)
      departmentSearching('')
      form.setFieldsValue({ [level]: { specialisation: '' } })
      form.setFieldsValue({ [level]: { department: option?.option?.name } })
      form.setFieldsValue({ [level]: { streamId: option?.option?.id } })
      form.setFieldsValue({ [level]: { specialisationId: '' } })
      setSpecialisationId([])
    }
  }

  //specialisation
  const specialisationSearching = async (specialisation = '') => {
    const specialisationResult = await searchAPI(
      searchConfig?.specialisations?.name,
      specialisation,
      searchConfig?.specialisations
    )
      .then(results => {
        setSpecialisationsSearchList(results)

        return results
      })
      .catch(error => {
        console.error(
          `Error searching ${searchConfig?.specialisations?.name}:`,
          error
        )
        return []
      })
    return specialisationResult || []
  }

  // const onSpecialisationChangeDrop = (data, option) => {
  //   if (data === 'OTHERS') {
  //     setShowOtherInputSpecialisation(true)
  //     specialisationSearching('')
  //     let otherSpecialisation = form
  //       .getFieldValue([[level], 'otherSpecialisation'])
  //       ?.trim('')
  //     form.setFieldsValue({ [level]: { specialisation: otherSpecialisation } })
  //     form.setFieldsValue({ [level]: { specialisationId: option?.option?.id } })
  //   } else {
  //     form.setFieldsValue({ [level]: { specialisation: option?.option?.name } })
  //     form.setFieldsValue({ [level]: { specialisationId: option?.option?.id } })
  //     setShowOtherInputSpecialisation(false)
  //     specialisationSearching('')
  //   }
  // }
  const onSpecialisationChangeDrop = (data, option, selectedOptions) => {
    if (data === 'OTHERS') {
      setShowOtherInputSpecialisation(true)
      specialisationSearching('')
      let otherSpecialisation = form
        .getFieldValue([[level], 'otherSpecialisation'])
        ?.trim('')
      form.setFieldsValue({ [level]: { specialisation: otherSpecialisation } })
      form.setFieldsValue({ [level]: { specialisationId: 'OTHERS' } })
      // Store array value for dropdown with mode=multiple - no need for objects here
      form.setFieldsValue({ [level]: { specialisationValue: [] } })
    } else {
      // Handle option as array of objects and extract names based on the console output structure
      const specialisationNames = Array.isArray(option) 
        ? option.map(opt => opt?.name).filter(Boolean).join(',') 
        : option?.name || ''
      form.setFieldsValue({ [level]: { specialisation: specialisationNames } })
      form.setFieldsValue({ [level]: { specialisationId: data } })
      setSpecialisationId(data)
      // Store array of objects with id and name properties for the dropdown
      const specialisationValueArray = Array.isArray(data) ? data : [data];
      const specialisationOptions = Array.isArray(option) ? option : [option];
      
      // Map IDs to objects with id and name properties
      const specialisationObjectArray = specialisationValueArray.map((id, index) => ({
        id: id,
        name: specialisationOptions[index]?.name || ''
      }));
      
      form.setFieldsValue({ [level]: { specialisationValue: specialisationObjectArray } })
      setShowOtherInputSpecialisation(false)
      specialisationSearching('')
    }
  }
  const universitySearching = async (university = '') => {
    const univResult = searchAPI(
      searchConfig?.universities?.name,
      university,
      searchConfig?.universities
    )
      .then(results => {
        setUniversitySearchList(results)
        return results
      })
      .catch(error => {
        console.error(
          `Error searching ${searchConfig?.universities?.name}:`,
          error
        )
        return []
      })

    return univResult || []
  }

  const onUniversityChange = (data, option) => {
    setErrorNote(prevError => ({
      ...prevError,
      university: '',
    }))
    setUniversityName(option?.option?.name)
    setUniversityId(option?.option?.id)
    form.setFieldsValue({ [level]: { university: option?.option?.name } })
    form.setFieldsValue({ [level]: { universityId: option?.option?.id } })
  }

  const delayUniversityToFetch = useCallback(
    debounce(data => {
      form.setFieldsValue({ [level]: { university: '' } })
      form.setFieldsValue({ [level]: { universityId: '' } })
      universitySearching(data)
    }, 500),
    []
  )

  const onStartMonthChange = (data, option) => {
    setStartMonth(data)
    form.setFieldsValue({ [level]: { startMonth: data } })
  }
  const onStartYearChange = (data, option) => {
    setStartYear(data)
    form.setFieldsValue({ [level]: { startYear: data } })
  }

  const onEndMonthChange = (data, option) => {
    setEndMonth(data)
    form.setFieldsValue({ [level]: { endMonth: data } })
  }
  const onEndYearChange = (data, option) => {
    setEndYear(data)
    form.setFieldsValue({ [level]: { endYear: data } })
  }

  const showHandler = () => {
    show ? setShow(false) : setShow(true)
    form.setFieldsValue({ [level]: { shown: show ? false : true } })
  }

  useEffect(() => {
    form.setFieldsValue({ [level]: { markSheetUrl: markSheetFile } })
    form.setFieldsValue({ [level]: { tcUrl: tcFile } })
  }, [markSheetFile, tcFile])

  //for Skills

  const updateSkillsData = () => {
    let sillsList = form?.getFieldValue([[level], 'skills']) || []
    let newSkillSet = []
    if (sillsList?.length && listOfSkills?.length && Array.isArray(sillsList)) {
      for (let skill of sillsList) {
        if (skill?.name && !skill?.id) {
          let skillObj = getValuebyName(listOfSkills, skill?.name)
          if (skillObj) {
            skill.id = skillObj.id

            newSkillSet.push({ id: skillObj?.id, name: skillObj?.name })
          }
        } else {
          newSkillSet.push(skill)
        }
      }
      form.setFieldsValue({
        [level]: { skills: newSkillSet?.length ? newSkillSet : [] },
      })
      setSelectedSkill(
        newSkillSet?.length ? newSkillSet?.filter(item => item && item.id).map(item => item.id) || [] : []
      )
      setStoreSkill(newSkillSet || [])
    }
    setSkillLoading(false)
  }
  const skillSearching = async (skillName = '') => {
    try {
      const result = await SkillsAPI(skillName)

      setListOfSkills(!skillName ? allSkills : result)
    } catch (err) {
      console.log(err)
    }
  }

  const delaySkillToFetch = useCallback(
    debounce(data => {
      skillSearching(data)
    }, 500),
    []
  )

  //*****************//
  const onSkillChange = (value, id) => {
    let list = []
    let skillList = []
    for (const item of id) {
      list.push(item?.id)
      let obj = {
        name: item?.name,
        id: item?.id,
      }
      skillList.push(obj)
    }
    setSelectedSkill(list)
    setStoreSkill(skillList)
    form.setFieldsValue({ [level]: { skills: skillList } })
    delaySkillToFetch('')
    if (skillList.length > 20) {
      setSkillErrorMsg('Maximum 20 Skills only allowed')
    } else {
      // Clear the error message if skillList is within the limit
      setSkillErrorMsg('')
    }
  }

  useLayoutEffect(() => {
    if (startDate && endDate) {
      setBatch(
        `${moment(form.getFieldValue([[level], 'startedOn']), 'MM/YYYY').format(
          'MMMM YYYY'
        ) +
        '-' +
        moment(form.getFieldValue([[level], 'endedOn']), 'MM/YYYY').format(
          'MMMM YYYY'
        )
        }`
      )
    }
  }, [startDate, endDate])

  useLayoutEffect(() => {
    if (startMonth && startYear) {
      let date = startMonth + '/' + startYear
      form.setFieldsValue({ [level]: { startedOn: date } })
      setStartDate(date)
    }
  }, [startMonth, startYear])

  useLayoutEffect(() => {
    if (endMonth && endYear) {
      let date = endMonth + '/' + endYear
      form.setFieldsValue({ [level]: { endedOn: date } })
      setEndDate(date)
    } else {
      form.setFieldsValue({ [level]: { endedOn: undefined } })
      setEndDate(undefined)
    }
  }, [endMonth, endYear])

  useLayoutEffect(() => {
    form.setFieldsValue({
      [level]: { educationLevel: getEducationLevel(level?.toLowerCase()) },
    })
  }, [level])
  const delayStateToFetch = useCallback(
    debounce(data => {
      getStateData(data)
      setErrorNote(prevError => ({
        ...prevError,
        state: '',
        city: '',
      }))
    }, 500),
    []
  )

  const checkType = data => {
    return data ? level === 'twelfth' : true
  }
  const onStateChange = (data, option) => {
    form.setFieldsValue({
      [level]: {
        state: option?.option?.name,
        stateId: option?.option?._id,
        city: '',
        cityId: '',
      },
    })
    setStateId(option?.option?._id)
    setCityId('')
    getCityData(option?.option?._id)
    setErrorNote(prevError => ({
      ...prevError,
      state: ``,
      city: ``,
    }))
    setStateError('')
    if (!isType) {
      if (option?.option?._id) {
        setLoadingInstitute(true)
        searchAPI(searchConfig?.institutesCampuses?.name, '', {
          ...searchConfig?.institutesCampuses,
          filters: [
            ...(searchConfig?.institutesCampuses?.filters || []),
            {
              type: 'match',
              field: 'state',
              value: option?.option?.name,
            },
          ],
        })
          .then(results => {
            if (isCurrentCourse) {
              setCurInstituteSearchList(results)
              setLoadingInstitute(false)
            } else {
              setInstituteSearchList(results)
              setLoadingInstitute(false)
            }
          })
          .catch(error =>
            console.error(
              `Error searching ${searchConfig?.institutesCampuses?.name}:`,
              error
            )
          )
        if (isCurrentCourse) {
          form.setFieldsValue({ [level]: { collegeName: '' } })
          form.setFieldsValue({ [level]: { collegeId: '' } })
        }
        form.setFieldsValue({ [level]: { institutionName: '' } })
        form.setFieldsValue({ [level]: { institutionId: '' } })
        setAddInstitute(false)
      } else {
        setLoadingInstitute(true)

        searchAPI(
          searchConfig?.institutesCampuses?.name,
          '',
          searchConfig?.institutesCampuses
        )
          .then(results => {
            if (isCurrentCourse) {
              setCurInstituteSearchList(results)
              setLoadingInstitute(false)
            } else {
              setInstituteSearchList(results)
              setLoadingInstitute(false)
            }
          })
          .catch(error =>
            console.error(
              `Error searching ${searchConfig?.institutesCampuses?.name}:`,
              error
            )
          )
      }
    }
    if (!data) getStateData('')
  }

  const getStateData = async search => {
    let list = await getListOfState('', search, true, setLoadingState)
    setStatesList(list)
    return list
  }
  const getCityData = async (
    stateId = '',
    search = '',
    cityId = '',
    fetching = false
  ) => {
    let cityName = search
    const results = await getListOfCity(
      '',
      stateId,
      cityName,
      true,
      setLoadingCity
    )
    setCityList(results)
    if (!fetching)
      if (results?.length && cityName) {
        let cityObj = results[0]
        if (
          cityObj?.name?.toLowerCase() == cityName?.toLowerCase() ||
          results?.length == 1
        ) {
          if (!cityId) {
            if (cityObj) {
              form.setFieldValue([[level], 'cityId'], cityObj?._id)
              form.setFieldValue([[level], 'city'], cityObj?.name)

              cityId = cityObj?._id
            }
            setErrorNote(prevError => ({
              ...prevError,
              city: ``,
            }))
            let stateName = form.getFieldValue([[level], 'state'])
            instituteSearching('', stateName, cityObj?.name)
            setCityId(cityId ?? cityObj?._id)
            setCityError('')
          }
        } else if (!cityId) {
          setErrorNote(prevError => ({
            ...prevError,
            city: results?.length
              ? `Searched results for : ${cityName}`
              : `No data matched for : ${cityName}`,
          }))
          form.setFieldValue([[level], 'city'], '')

          if (!results?.length) {
            let result = await getListOfCity(
              '',
              stateId,
              '',
              false,
              setLoadingCity
            )
            setCityList(result)
          }
        }
      } else if (cityName && !cityId) {
        setErrorNote(prevError => ({
          ...prevError,
          city: results?.length
            ? `Searched results for : ${cityName}`
            : `No data matched for : ${cityName}`,
        }))
        form.setFieldValue([[level], 'city'], '')
        let stateName = form.getFieldValue([[level], 'state'])
        instituteSearching('', stateName)

        if (!results?.length) {
          let result = await getListOfCity(
            '',
            stateId,
            '',
            false,
            setLoadingCity
          )
          setCityList(result)
        }
      }
  }

  const updateDegreeData = async () => {
    let degreeId = form.getFieldValue([[level], 'degreeId'])
    let degree = form.getFieldValue([[level], 'degree'])
    const results = await degreeSearching(degree)
    if (!degreeId && degree) {
      form.setFieldValue([[level], 'degree'], '')
      if (results?.length) {
        let degreeObj = results[0]

        if (
          degreeObj?.name?.toLowerCase() == degree?.toLowerCase() ||
          results?.length == 1
        ) {
          if (degreeObj) {
            form.setFieldValue([[level], 'degreeId'], degreeObj?.id)
            form.setFieldValue([[level], 'degree'], degreeObj?.name)
          }
        } else {
          setErrorNote(prevError => ({
            ...prevError,
            degree: results?.length
              ? `Searched results for : ${degree}`
              : `No data matched for : ${degree}`,
          }))

          if (!results?.length) degreeSearching('')
          form.setFieldValue([[level], 'degree'], '')
        }
      } else {
        setErrorNote(prevError => ({
          ...prevError,
          degree: results?.length
            ? `Searched results for : ${degree}`
            : `No data matched for : ${degree}`,
        }))

        if (!results?.length) degreeSearching('')
        form.setFieldValue([[level], 'degree'], '')
      }
    } else {
      degreeSearching('')
    }
  }

  const updateDepartmentData = async () => {
    let department = form.getFieldValue([[level], 'department'])
    let departmentId = form.getFieldValue([[level], 'streamId'])
    const results = await departmentSearching(department)
    if (!departmentId && department) {
      form.setFieldValue([[level], 'department'], '')
      if (results?.length) {
        let departmentObj = results[0]
        if (
          departmentObj?.name?.toLowerCase() == department?.toLowerCase() ||
          results?.length == 1
        ) {
          if (departmentObj) {
            form.setFieldValue([[level], 'streamId'], departmentObj?.id)
            form.setFieldValue([[level], 'department'], departmentObj?.name)
          }
        } else {
          setErrorNote(prevError => ({
            ...prevError,
            department: results?.length
              ? `Searched results for : ${department}`
              : `No data matched for : ${department}`,
          }))

          if (!results?.length) departmentSearching('')
          form.setFieldValue([[level], 'department'], '')
        }
      } else {
        setErrorNote(prevError => ({
          ...prevError,
          department: results?.length
            ? `Searched results for : ${department}`
            : `No data matched for : ${department}`,
        }))

        if (!results?.length) departmentSearching('')
        form.setFieldValue([[level], 'department'], '')
      }
    } else {
      departmentSearching('')
    }
  }

  const updateSpecialisationData = async () => {
    let specialisation = form.getFieldValue([[level], 'specialisation'])
    let specialisationId = form.getFieldValue([[level], 'specialisationId'])
    const results = await specialisationSearching(specialisation)
    if (!specialisationId && specialisation) {
      form.setFieldValue([[level], 'specialisation'], '')
      if (results?.length) {
        let specialisationObj = results[0]
        if (
          specialisationObj?.name?.toLowerCase() ==
          specialisation?.toLowerCase() ||
          results?.length == 1
        ) {
          if (specialisationObj) {
            form.setFieldValue(
              [[level], 'specialisationId'],
              specialisationObj?.id
            )
            form.setFieldValue(
              [[level], 'specialisation'],
              specialisationObj?.name
            )
          }
        } else {
          setErrorNote(prevError => ({
            ...prevError,
            specialisation: results?.length
              ? `Searched results for : ${specialisation}`
              : `No data matched for : ${specialisation}`,
          }))

          if (!results?.length) specialisationSearching('')

          form.setFieldValue([[level], 'specialisation'], '')
        }
      } else {
        setErrorNote(prevError => ({
          ...prevError,
          specialisation: results?.length
            ? `Searched results for : ${specialisation}`
            : `No data matched for : ${specialisation}`,
        }))

        if (!results?.length) specialisationSearching('')

        form.setFieldValue([[level], 'specialisation'], '')
      }
    } else {
      specialisationSearching('')
    }
  }

  const updateUniversityData = async () => {
    let universityId = form.getFieldValue([[level], 'universityId'])
    let university = form.getFieldValue([[level], 'university'])
    const results = await universitySearching(university)
    if (results?.length) {
      if (!universityId && university) {
        if (results?.length && results?.length == 1) {
          form.setFieldValue([[level], 'university'], '')
          let universityObj = results[0]
          if (universityObj) {
            setUniversityId(universityObj?.id)
            form.setFieldValue([[level], 'universityId'], universityObj?.id)
            setUniversityName(universityObj?.name)
          }
        } else {
          setErrorNote(prevError => ({
            ...prevError,
            university: results?.length
              ? `Searched results for : ${university}`
              : `No data matched for : ${university}`,
          }))

          if (!results?.length) universitySearching('')
          form.setFieldValue([[level], 'university'], '')
          setUniversityName('')
        }
      } else {
        universitySearching('')
      }
    } else {
      setErrorNote(prevError => ({
        ...prevError,
        university: results?.length
          ? `Searched results for : ${university}`
          : `No data matched for : ${university}`,
      }))

      if (!results?.length) universitySearching('')
      form.setFieldValue([[level], 'university'], '')
      setUniversityName('')
    }
  }
  const fetchStateCity = async (stateName = '', cityName = '') => {
    let stateId = form.getFieldValue([[level], 'stateId'])
    let state = stateName || form.getFieldValue([[level], 'state'])
    let cityId = form.getFieldValue([[level], 'cityId'])
    let city = cityName || form.getFieldValue([[level], 'city'])
    const results = await getStateData(state)

    if (results?.length && state) {
      let stateObj = results[0]
      if (
        stateObj?.name?.toLowerCase() == state?.toLowerCase() ||
        results?.length == 1
      ) {
        if (!stateId) {
          if (stateObj) {
            form.setFieldValue([[level], 'stateId'], stateObj?._id)
            form.setFieldValue([[level], 'state'], stateObj?.name)
            stateId = stateObj?._id
            state = stateObj?.name
            setStateId(stateId)
            setStateError('')
            setCityError('')
            setErrorNote(prevError => ({
              ...prevError,
              state: ``,
            }))
          }
        }

        await getCityData(stateId, city, cityId)
      } else if (state && !stateId) {
        setErrorNote(prevError => ({
          ...prevError,
          state: results?.length
            ? `Searched results for : ${state}`
            : `No data matched for : ${state}`,
        }))

        if (!results?.length) {
          await getStateData('')
        }
        form.setFieldValue([[level], 'state'], '')
        form.setFieldValue([[level], 'city'], '')
      }
    } else if (state && !stateId) {
      setErrorNote(prevError => ({
        ...prevError,
        state: results?.length
          ? `Searched results for : ${state}`
          : `No data matched for : ${state}`,
      }))

      if (!results?.length) {
        await getStateData('')
      }
      form.setFieldValue([[level], 'state'], '')
      form.setFieldValue([[level], 'city'], '')
    }
  }
  const fetchInitialData = async () => {
    let campusName = form.getFieldValue([
      [level],
      isCurrentCourse ? 'collegeName' : 'institutionName',
    ])
    let state = form.getFieldValue([[level], 'state'])
    let city = form.getFieldValue([[level], 'city'])
    await fetchStateCity(state, city)
    if ((state || city) && !isType) {
      const filters = []
      if (city) {
        filters.push({
          type: 'match',
          field: 'city',
          value: city,
        })
      }
      if (state) {
        filters.push({
          type: 'match',
          field: 'state',
          value: state,
        })
      }
      if (!campusName) {
        setLoadingInstitute(true)

        searchAPI(searchConfig?.institutesCampuses?.name, '', {
          ...searchConfig?.institutesCampuses,
          filters: [
            ...(searchConfig?.institutesCampuses?.filters || []),
            ...filters,
          ],
        })
          .then(results => {
            if (isCurrentCourse) {
              setCurInstituteSearchList(results)
              setLoadingInstitute(false)
            } else {
              setInstituteSearchList(results)
              setLoadingInstitute(false)
            }
          })
          .catch(error =>
            console.error(
              `Error searching ${searchConfig?.institutesCampuses?.name}:`,
              error
            )
          )
      }
    }
  }

  const onCityChange = (data, option) => {
    setErrorNote(prevError => ({
      ...prevError,
      city: ``,
    }))
    setCityError('')
    form.setFieldsValue({
      [level]: { city: data, cityId: option?.option?._id },
    })
    let stateName = form.getFieldValue([[level], 'state'])
    setCityId(option?.option?._id)
    if (!isType) {
      if (option?.option?._id) {
        const filters = []
        if (option?.option?.name) {
          filters.push({
            type: 'match',
            field: 'city',
            value: option?.option?.name,
          })
        }
        if (stateName) {
          filters.push({
            type: 'match',
            field: 'state',
            value: stateName,
          })
        }
        setLoadingInstitute(true)
        searchAPI(searchConfig?.institutesCampuses?.name, '', {
          ...searchConfig?.institutesCampuses,
          filters: [
            ...(searchConfig?.institutesCampuses?.filters || []),
            ...filters,
          ],
        })
          .then(results => {
            if (isCurrentCourse) {
              setCurInstituteSearchList(results)
              setLoadingInstitute(false)
            } else {
              setInstituteSearchList(results)
              setLoadingInstitute(false)
            }
          })
          .catch(error =>
            console.error(
              `Error searching ${searchConfig?.institutesCampuses?.name}:`,
              error
            )
          )
        if (isCurrentCourse) {
          form.setFieldsValue({ [level]: { collegeName: '' } })
          form.setFieldsValue({ [level]: { collegeId: '' } })
        }
        form.setFieldsValue({ [level]: { institutionName: '' } })
        form.setFieldsValue({ [level]: { institutionId: '' } })
        setAddInstitute(false)
      } else {
        const filters = []
        if (stateName) {
          filters.push({
            type: 'match',
            field: 'state',
            value: stateName,
          })
        }
        setLoadingInstitute(true)

        searchAPI(searchConfig?.institutesCampuses?.name, '', {
          ...searchConfig?.institutesCampuses,
          filters: [
            ...(searchConfig?.institutesCampuses?.filters || []),
            ...filters,
          ],
        })
          .then(results => {
            if (isCurrentCourse) {
              setCurInstituteSearchList(results)
              setLoadingInstitute(false)
            } else {
              setInstituteSearchList(results)
              setLoadingInstitute(false)
            }
          })
          .catch(error =>
            console.error(
              `Error searching ${searchConfig?.institutesCampuses?.name}:`,
              error
            )
          )
      }
    }
    if (!data) getCityData(form.getFieldValue([[level], 'stateId']), data)
  }

  const delayCityToFetch = useCallback(
    debounce(data => {
      getCityData(form.getFieldValue([[level], 'stateId']), data, '', true)
      setErrorNote(prevError => ({
        ...prevError,
        city: ``,
      }))
    }, 500),
    []
  )

  const validateStartEndDate = (rule, value, callback) => {
    if (
      startDate &&
      endDate &&
      moment(startDate, 'MM/YYYY').isAfter(moment(endDate, 'MM/YYYY'))
    ) {
      return Promise.reject(
        new Error(`End date should be greater than start date`)
      )
    } else {
      return Promise.resolve()
    }
  }

  const awardHandle = (isAdd, isDelete, deleteForm) => {
    const experienceKeys = Object.keys(form.getFieldValue())
    let lastValue = 0
    for (let i = experienceKeys.length - 1; i >= 0; i--) {
      const key = experienceKeys[i]
      const intValue = parseInt(key.split('+')[1])
      if (!isNaN(intValue)) {
        lastValue = intValue
        break
      }
    }
    let arr = []
    let formName1 = level + 'award+' + `${lastValue + 1}`

    arr.push({ component: WorkExpAwardForm, formName: formName1 })
    if (isAdd) {
      setAward(exp => exp.concat(arr))
    }
    if (isDelete) {
      let updatedList = award?.filter(data => data?.formName !== deleteForm)
      return setAward(updatedList)
    }
  }

  const delayToFetchDegree = useCallback(
    debounce(data => {
      degreeSearching(data)
      form.setFieldsValue({ [level]: { otherDegree: data } })
    }, 500),
    []
  )

  //department
  const departmentSearching = async (department = '') => {
    const departmentResult = await searchAPI(
      searchConfig?.streams?.name,
      department,
      searchConfig?.streams
    )
      .then(results => {
        setDepartmentSearchList(results)
        return results
      })
      .catch(error => {
        console.error(`Error searching ${searchConfig?.streams?.name}:`, error)
        return []
      })
    return departmentResult || []
  }
  const delayToFetchDepartment = useCallback(
    debounce(data => {
      departmentSearching(data)
      form.setFieldsValue({ [level]: { otherDepartment: data } })
    }, 500),
    []
  )

  const delayToFetchSpecialisation = useCallback(
    debounce(data => {
      form.setFieldsValue({ [level]: { specialisationId: '' } })
      form.setFieldsValue({ [level]: { specialisation: '' } })
      if (isCurrentCourse)
        fetchSpecialisation(
          data,
          form.getFieldValue([[level], 'degreeId']),
          form.getFieldValue([[level], 'streamId'])
        )
      else specialisationSearching(data)

      form.setFieldsValue({ [level]: { otherSpecialisation: data } })
    }, 500),
    []
  )
  const onInstituteCampusChange = (data, option) => {
    if (data?.toUpperCase() === 'OTHER') {
      setInstituteCampusName(null)
      form.setFieldsValue({ [level]: { addInstitute: data } })
      form.setFieldsValue({
        [level]: { institutionId: 'OTHERS' },
      })
      setAddInstitute(true)
      form.setFieldsValue({ [level]: { instituteName: '' } })
    } else {
      setInstituteCampusName(data)
      form.setFieldsValue({
        [level]: { addInstitute: null },
      })
      form.setFieldsValue({
        [level]: { institutionName: option?.option?.instituteName },
      })
      form.setFieldsValue({
        [level]: { institutionId: option?.option?.instituteId },
      })
    }

    if (!data) {
      instituteSearching('', stateName, cityName)
    }
    if (option?.option?.state || option?.option?.city) {
      let state = option.option.state || ''
      let city = option.option?.city || ''
      fetchStateCity(state, city)
    }
  }

  const validateSkill = (rule, value, callback) => {
    if (storeSkill.length > 20) {
      setSkillErrorMsg('')
      return Promise.reject(new Error('Maximum 20 Skills only allowed'))
    } else {
      return Promise.resolve()
    }
  }
  const validateSpecialisation = (rule, value, callback) => {
    if (specialisationId.length > 2) {
      
      return Promise.reject(new Error('Maximum 2 Specialisation only allowed'))
    } else {
      return Promise.resolve()
    }
  }

  //Get Initial Data
  useEffect(() => {
    instituteSearching('')
  }, [])
  const instituteSearching = async (institute = ' ', state, city) => {
    const filters = []
    if (state) {
      filters.push({
        type: 'match',
        field: 'state',
        value: state,
      })
    }
    if (city) {
      filters.push({
        type: 'match',
        field: 'city',
        value: city,
      })
    }
    setLoadingInstitute(true)

    const result = await searchAPI(
      searchConfig?.institutesCampuses?.name,
      institute,
      {
        ...searchConfig?.institutesCampuses,
        filters: [
          ...(searchConfig?.institutesCampuses?.filters || []),
          ...filters,
        ],
      }
    )
      .then(results => {
        if (isCurrentCourse) {
          setCurInstituteSearchList(results)
          setLoadingInstitute(false)
        } else {
          setInstituteSearchList(results)
          setLoadingInstitute(false)
        }
        return results
      })
      .catch(error =>
        console.error(
          `Error searching ${searchConfig?.institutesCampuses?.name}:`,
          error
        )
      )
    return result
  }
  const handleStateValidation = () => {
    setStateError('Please select state!')
  }
  const handleCityValidation = () => {
    setCityError('Please select city!')
  }
  const delayInstituteToFetch = useCallback(
    debounce(data => {
      let stateName = form.getFieldValue([[level], 'state'])
      let cityName = form.getFieldValue([[level], 'city'])
      instituteSearching(data, stateName, cityName)
      if (isCurrentCourse) {
        form.setFieldsValue({ [level]: { collegeName: '' } })
        form.setFieldsValue({ [level]: { collegeId: '' } })
      } else {
        form.setFieldsValue({ [level]: { institutionName: '' } })
        form.setFieldsValue({ [level]: { institutionId: '' } })
        setAddInstitute(false)
      }
      setErrorNote(prevError => ({
        ...prevError,
        institutionName: '',
      }))
    }, 500),
    []
  )

  const onInstituteChange = (data, option) => {
    let stateName = form.getFieldValue([[level], 'state'])
    let cityName = form.getFieldValue([[level], 'city'])
    setCurrentInstituteName(option?.option?.campusName)
    setCurrentInstituteId(option?.option?.id)
    form.setFieldsValue({
      [level]: { collegeName: option?.option?.campusName },
    })
    form.setFieldsValue({ [level]: { collegeId: option?.option?.id } })
    if (!data) {
      instituteSearching('', stateName, cityName)
    }
    if (option?.option?.state || option?.option?.city) {
      let state = option.option.state || ''
      let city = option.option?.city || ''
      fetchStateCity(state, city)
    }
  }
  const onBlurHandler = key => {
    if (!form.getFieldValue([[level], [key]])?.trim()) {
      form.setFieldsValue({ [level]: { [key]: '' } })
    }
  }

  const onRemoveEducationClicked = () => {
    setErrorNote(initialErrorState)
    setDeleted(true)
    setTimeout(() => {
      onRemoveEducation(level, educationId)
    }, 1000)
  }
  return (
    <>
      {!deleted && (
        <Container column flexStart>
          <Control spaceBetween alignCenter>
            <Control column flexStart>
              <Control alignCenter gap="10px">
                <Heading>{label}</Heading>
                {requestId && (
                  <CustomTag
                    message="Verification Pending"
                    bordered={true}
                    background={'#eb5d60'}
                    border={'#eb5d60'}
                    color={'#fff'}
                  />
                )}
              </Control>
              <SubHeading>
                {isType
                  ? endDate
                    ? moment(
                      form.getFieldValue([[level], 'endedOn']),
                      'MM/YYYY'
                    ).format('YYYY')
                    : null
                  : batch}
              </SubHeading>
            </Control>
            <Control gap="10px" flexEnd>
              {isType
                ? null
                : moment(form.getFieldValue([[level], 'endedOn'])).format(
                  'YYYY-MM-DD'
                ) > currentDate.format('YYYY-MM-DD')
                  ? isCurrentCourse && (
                    <CurrentWrapper>
                      <CurrentText>Currently Pursuing</CurrentText>
                    </CurrentWrapper>
                  )
                  : null}
              <IconView>
                {!isCurrentCourse && level != 'tenth' && (
                  <Delete
                    disabled={isCurrentCourse}
                    onClick={() => onRemoveEducationClicked()}
                  />
                )}
              </IconView>
              <IconView onClick={() => showHandler()}>
                <Dropdown />
              </IconView>
            </Control>
          </Control>
          <StyledFormItem show={form.getFieldValue([[level], 'shown'])}>
              <FormItem name={[[level], 'id']} />
              <FormItem name={[[level], 'educationLevel']} />
              <FormItem name={[[level], 'institutionId']} />
                          <FormItem name={[[level], 'collegeId']} />
                          <FormItem name={[[level], 'collegeName']} />
                          <FormItem name={[[level], 'specialisationId']} />
                          <FormItem name={[[level], 'specialisation']} />
                          <FormItem name={[[level], 'degree']} />
                          <FormItem name={[[level], 'department']} />
            {isType ?
              <>
              
                <Control row gap="20px">
                  <Control width="49%" column>
                    <FormItem name={[[level], 'board']}>
                      <div></div>
                    </FormItem>
                    <LabelWithPending fieldName="board">Board</LabelWithPending>

                    <AntdSelect
                      showSearch={true}
                      placeholder="Eg. State Board"
                      name={[[level], 'board']}
                      rules={[]}
                      OptionData={boardList}
                      valueParam="name"
                      nameParam="name"
                      type={'string'}
                      onChange={onBoardChange}
                      value={boardName ?? form.getFieldValue([[level], 'board'])}
                      allowClear={true}
                      UpperCase={true}
                    />
                  </Control>

                  <Control width="49%" column>
                    <FormItem   rules={[
                    {
                      required: true,
                      message: 'Please select year!',
                    },
                  ]} name={[[level], 'endedYear']}>
                      <Label > Year * </Label>
                   <Date
                 style={{ marginTop: '8px' }}
                                      placeholder="Please Select the year"
                                      onChange={onDateChange}
                                      format="YYYY"
                                      picker="year"
                                      value={endedYear ? moment(endedYear) : null}
                                      inputReadOnly
                                       disabledDate={d => !d || d.isAfter(moment())}
                                    />
                    </FormItem>

                    
                  </Control>


                </Control>
                <Control row gap="20px" top="15px">


                  <Control width="49%" column>
                    <LabelWithPending fieldName="marks">
                      <span>Marks (percentage) *</span>
                    </LabelWithPending>
                    <AntdInput
                      width="100%"
                      placeholder="Eg. 80.00"
                      name={[[level], 'marks']}
                      onInput={e => {
                        e.target.value = e.target.value.replace(
                          /[^0-9.]/g,
                          ''
                        )
                      }}
                      suffix={<PercentIcon />}
                      rules={[
                        {
                          validator: (_, value) => {
                            let isValid = validateNumber(value)
                            if (!isValid) {
                              return Promise.reject(
                                'Please enter valid marks in Percentage!'
                              )
                            }
                            if (value <= 30) {
                              return Promise.reject(
                                'Percentage must be greater than 30'
                              )
                            }
                            return Promise.resolve()
                          },
                        },
                      ]}
                    />
                  </Control>
                </Control>
                <FormItem name={[[level], 'markSheetUrl']}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <Label style={{ marginTop: '16px', color: '#9B9B9B' }}>
                      {getMarksheetLabel(level)} 
                    </Label>

                    {markSheetFile && (markSheetFile.url || markSheetFile.name) ? (

                      <FileReader
                        file={markSheetFile}
                        onDelete={() => {
                        setMarkSheetFile(null)
                        form.setFieldsValue({
                          [level]: { markSheetUrl: null },
                        })
                      }}
                      />
                    ) : (
                      <Uploadloader
                        variant="simple"
                        file={markSheetFile}
                        setFile={file => {
                          setMarkSheetFile(file)
                          form.setFieldsValue({
                            [level]: { markSheetUrl: file },
                          })
                        }}
                        fileName={`${studentFormData?.fullName
                          ?.toLowerCase()
                          ?.replace(/\s/g, '')}_marksheet`}
                        onlyDoc={false}
                      />
                    )}
                  </div>
                </FormItem>
              </> :
              <>
                {isCurrentCourse ? (
                  <>
                   
                    <FormItem name={[[level], 'noOfArrears']}/>
                  <>
                                   <Control gap="20px">
                                     <Control flexStart column>
                                       <FormItem name={[[level], 'state']} />
                                       <FormItem name={[[level], 'stateId']}>
                                         <div> </div>
                                       </FormItem>
                                       <LabelWithPending fieldName="state">State *</LabelWithPending>
                 
                                       <AntdSelect
                                         allowClear={true}
                                         placeholder="Select"
                                         name={[[level], 'stateId']}
                                         // rules={[
                                         //   {
                                         //     validator: async (_, value) => {
                                         //       if (
                                         //         !form.getFieldValue([[level], 'stateId']) ||
                                         //         !form.getFieldValue([[level], 'stateId'])
                                         //       ) {
                                         //         return Promise.reject(
                                         //           new Error('Please select a state!')
                                         //         )
                                         //       }
                                         //       return Promise.resolve()
                                         //     },
                                         //   },
                                         // ]}
                                         OptionData={statesList}
                                         notFoundContent={
                                           loadingState ? (
                                             <SpinWrapper center>
                                               <Spin />
                                             </SpinWrapper>
                                           ) : (
                                             <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                           )
                                         }
                                         valueParam="name"
                                         nameParam="name"
                                         onChange={onStateChange}
                                         value={form.getFieldValue([[level], 'state'])}
                                         showSearch={true}
                                         onSearch={data => delayStateToFetch(data)}
                                         iskey={true}
                                         filterOption={false}
                                         disabled={isCurrentCourse}
                                         onBlur={() => onBlurHandler('state')}
                                       />
                                       {!errorNote?.state && stateError != '' && (
                                         <RedNote>{stateError}</RedNote>
                                       )}
                                       {errorNote?.state && <RedNote>{errorNote?.state}</RedNote>}
                                     </Control>
                 
                                     <Control flexStart column>
                                       <FormItem name={[[level], 'city']} />
                                       <FormItem name={[[level], 'cityId']}>
                                         <div></div>
                                       </FormItem>
                                       <LabelWithPending fieldName="city">City *</LabelWithPending>
                                       <AntdSelect
                                         allowClear={true}
                                         placeholder="Select"
                                         name={[[level], 'cityId']}
                                         // rules={[
                                         //   {
                                         //     validator: async (_, value) => {
                                         //       if (
                                         //         !form.getFieldValue([[level], 'city']) ||
                                         //         !form.getFieldValue([[level], 'cityId'])
                                         //       ) {
                                         //         // handleCityValidation()
                                         //         return Promise.reject('Please select city!')
                                         //       }
                                         //       return Promise.resolve()
                                         //     },
                                         //   },
                                         // ]}
                                         OptionData={cityList}
                                         notFoundContent={
                                           loadingCity ? (
                                             <SpinWrapper center>
                                               <Spin />
                                             </SpinWrapper>
                                           ) : (
                                             <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                           )
                                         }
                                         valueParam="name"
                                         nameParam="name"
                                         onChange={onCityChange}
                                         value={form.getFieldValue([[level], 'city'])}
                                         disabled={
                                           isCurrentCourse ||
                                           form.getFieldValue([[level], 'state']) === '' ||
                                           form.getFieldValue([[level], 'state']) === undefined
                                         }
                                         showSearch={true}
                                         onSearch={data => delayCityToFetch(data)}
                                         iskey={true}
                                         filterOption={false}
                                       />
                                       {!errorNote?.city && cityError != '' && (
                                         <RedNote>{cityError}</RedNote>
                                       )}
                                       {errorNote?.city && <RedNote>{errorNote?.city}</RedNote>}
                                     </Control>
                                   </Control>
                 
                                   <Control row gap="20px" top="15px">
                                     <Control width="100%" column>
                                       <LabelWithPending fieldName="collegeName">{isType ? 'School Name *' : 'College Name *'} </LabelWithPending>
                                       <FormItem
                                         name={[
                                           [level],
                                           isCurrentCourse ? 'collegeName' : 'institutionName',
                                         ]}
                                       >
                                         <div> </div>
                                       </FormItem>
                                       <AntdSelect
                                         placeholder="Select Institute"
                                         name={[
                                           [level],
                                           isCurrentCourse ? 'collegeName' : 'institutionName',
                                         ]}
                                         nameParam="campusName"
                                         valueParam="id"
                                         filterOption={false}
                                         showSearch={true}
                                         onClear={() => delayInstituteToFetch('')}
                                         OptionData={
                                           loadingInstitute
                                             ? []
                                             : isCurrentCourse
                                               ? curInstituteSearchList
                                               : [
                                                 ...instituteSearchList,
                                                 {
                                                   campusName: 'Other',
                                                   id: 'OTHER',
                                                   isActive: 'true',
                                                 },
                                               ] || []
                                         }
                                         notFoundContent={
                                           loadingInstitute ? (
                                             <SpinWrapper center>
                                               <Spin />
                                             </SpinWrapper>
                                           ) : (
                                             <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                           )
                                         }
                                         rules={[
                                           {
                                             required: true,
                                             message: 'Please select an institute.',
                                           },
                                         ]}
                                         onSearch={data =>
                                           data?.trim()
                                             ? delayInstituteToFetch(data?.trim())
                                             : delayInstituteToFetch('')
                                         }
                                         onChange={
                                           isCurrentCourse
                                             ? onInstituteChange
                                             : onInstituteCampusChange
                                         }
                                         value={
                                           form.getFieldValue([[level], 'addInstitute']) &&
                                             form.getFieldValue([[level], 'institutionId']) ===
                                             'OTHERS'
                                             ? 'Other'
                                             : form.getFieldValue([
                                               [level],
                                               isCurrentCourse
                                                 ? 'collegeName'
                                                 : 'institutionName',
                                             ])
                                         }
                                         disabled={isCurrentCourse}
                                         iscampusLocationshow={true}
                                         onBlur={() =>
                                           onBlurHandler(
                                             isCurrentCourse ? 'collegeName' : 'institutionName'
                                           )
                                         }
                                       />
                                     </Control>
                 
                 
                 
                                   </Control>
                                   {addInstitute && (
                                     <Control top="10px" row>
                                       <Control column width="100%">
                                         <Label>Please enter the Institute name *</Label>
                                         <AntdInput
                                           placeholder="Enter the Institute name"
                                           name={[
                                             [level],
                                             isCurrentCourse ? 'collegeName' : 'institutionName',
                                           ]}
                                           value={form.getFieldValue([[level], 'instituteName'])}
                                           rules={[
                                             {
                                               required: true,
                                               message: 'Please enter the Institute name.',
                                             },
                                           ]}
                                         />
                                       </Control>
                                     </Control>
                                   )}
                                   <Control row gap="20px" top="15px">
                                     <Control width="100%" column>
                                       <LabelWithPending fieldName="university">University </LabelWithPending>
                                       <FormItem name={[[level], 'universityId']} />
                                       <AntdSelect
                                         allowClear
                                         placeholder="Eg.University of Delhi"
                                         name={[[level], 'university']}
                                         onClear={() => delayUniversityToFetch('')}
                                         rules={[
                                           {
                                             required: false,
                                             message: 'Please select university!',
                                           },
                                         ]}
                                         OptionData={universitySearchList || []}
                                         valueParam="id"
                                         nameParam="name"
                                         showSearch={true}
                                         onSearch={data =>
                                           data?.trim()
                                             ? delayUniversityToFetch(data?.trim())
                                             : delayUniversityToFetch('')
                                         }
                                         onChange={onUniversityChange}
                                         value={form.getFieldValue([[level], 'university'])}
                                         filterOption={false}
                                         onBlur={() => onBlurHandler(form.getFieldValue([[level], 'university']))}
                                       />
                                       {errorNote?.university && (
                                         <RedNote>{errorNote?.university}</RedNote>
                                       )}
                                     </Control>
                 
                                   </Control>
                 
                                   <Control row gap="20px" top="15px">
                                     <Control width="49%" column>
                                       <FormItem rules={[
                                         {
                                           required: true,
                                           message: 'Please select year!',
                                         },
                                       ]} name={[[level], 'endedYear']}>
                                         <Label> Year *</Label>
                                         <Date
                                           style={{ marginTop: '8px' }}
                 
                                           placeholder="Please Select the year"
                                           onChange={onDateChange}
                                           format="YYYY"
                                           picker="year"
                                           value={endedYear ? moment(endedYear) : null}
                                           inputReadOnly
                                           disabled={true}
                                         />
                                       </FormItem>
                 
                                     </Control>
                 
                                     <Control width="49%" column>
                                       <Label>
                                         <span>History of Arrears</span>
                                       </Label>
                                       <AntdInput
                                         width="100%"
                                         placeholder="Enter no. History of arrears"
                                         name={[[level], 'historyOfArrears']}
                                         onInput={e => {
                                           e.target.value = e.target.value.replace(/[^0-9.]/g, '')
                                         }}
                                         rules={[
                                           {
                                             required: false,
                                             message: 'Please enter No. Of History of Arrears!',
                                           },
                                           {
                                             validator: (_, value) => {
                                               if (
                                                 value === undefined ||
                                                 value === null ||
                                                 value === ''
                                               ) {
                                                 return Promise.resolve() // Resolves the promise if the field is empty
                                               }
                                               if (value >= 0 && value < 100) {
                                                 return Promise.resolve()
                                               } else {
                                                 return Promise.reject(
                                                   new Error(
                                                     'Please enter valid No. Of History of Arrears!'
                                                   )
                                                 )
                                               }
                                             },
                                           },
                                         ]}
                                       />
                                     </Control>
                 
                 
                                   </Control>
                 
                                   <Control row gap="20px" top="15px">
                 
                                     <Control width="49%" column>
                                       <LabelWithPending fieldName={markType === 'Percentage' ? 'marks' : 'cgpaValue'}>
                                         <span>{markType === 'Percentage' ? `Marks (percentage)` : `CGPA`}</span>
                                       </LabelWithPending>
                                       <Control>
                 
                                         <StyledInputDivRight>
                                           <AntdInput
                                             width="100%"
                                             placeholder={`${markType === 'Percentage' ? 'Eg. 80.00' : 'Eg. 8.00'}`}
                                             name={[[level], `${markType === 'Percentage' ? 'marks' : 'cgpaValue'}`]}
                                             onInput={e => {
                                               e.target.value = e.target.value.replace(
                                                 /[^0-9.]/g,
                                                 ''
                                               )
                                             }}
                                             onBlur={recalculateMarks}
                                             disabled={markType === 'Percentage' ? (frozenFields?.marks || frozenFields?.averageMarks || false) : (frozenFields?.cgpaValue || false)}
                                             rules={[
                                               {
                                                 validator: (_, value) => {
                                                   let isValid = validateNumber(value)
                                                   if (!isValid) {
                                                     return Promise.reject(
                                                       'Please enter valid marks in Percentage!'
                                                     )
                                                   }
                                                   if (value > 100 && markType === 'Percentage') {
                                                     return Promise.reject(
                                                       'Percentage must be less than or equal to 100'
                                                     )
                                                   }
                                                   if (value > 10 && markType === 'CGPA') {
                                                     return Promise.reject(
                                                       'CGPA must be less than or equal to 10'
                                                     )
                                                   }
                                                   return Promise.resolve()
                                                 },
                                               },
                                             ]}
                                           />
                                         </StyledInputDivRight>
                                         <StyledSelectDivLeft>
                                           <AntdSelect
                                             width="100%"
                                             OptionData={markTypeList}
                                             nameParam="value"
                                             bordered={false}
                                             placeholder="Percentage"
                                             onChange={onMarkTypeChange}
                                             value={markType}
                                             allowClear={false}
                                             disabled={markType === 'Percentage' ? (frozenFields?.marks || frozenFields?.averageMarks || false) : (frozenFields?.cgpaValue || false)}
                                           />
                                         </StyledSelectDivLeft>
                                       </Control>
                                     </Control>
                 
                                     <Control width="49%" column>
                                       {markType === "CGPA" &&
                                         (<>
                 
                                           <Label>
                                             <span>Enter CGPA out of *</span>
                                           </Label>
                                           <AntdInput
                                             width="100%"
                                             placeholder="Percentage"
                                             name={[[level], 'cgpaOutof']}
                                             defaultValue="0.00"
                                             onInput={e => {
                                               e.target.value = e.target.value.replace(
                                                 /[^0-9.]/g,
                                                 ''
                                               )
                                             }}
                                             onChange={recalculateMarks}
                                             rules={[
                                               {
                                                 validator: (_, value) => {
                                                   let isValid = validateNumber(value)
                                                   if (!isValid) {
                                                     return Promise.reject(
                                                       'Please enter valid marks in CGPA!'
                                                     )
                                                   }
                                                   if (value > 10) {
                                                     return Promise.reject(
                                                       'CGPA must be less than 10'
                                                     )
                                                   } if (value < 5) {
                                                     return Promise.reject(
                                                       'CGPA must be greater than or Equals to 5'
                                                     )
                                                   }
                                                   return Promise.resolve()
                                                 },
                                               },
                                             ]}
                                           />
                                           <FormItem name={[[level], 'marks']} rules={[
                                             {
                                               validator: (_, value) => {
                                                 let isValid = validateNumber(value)
                                                 if (!isValid) {
                                                   return Promise.reject(
                                                     `Please enter valid marks in ${markType === 'Percentage' ? 'Percentage' : 'CGPA'}`
                                                   )
                                                 }
                                                //  if (value <= 30) {
                                                //    return Promise.reject(
                                                //      'Percentage must be greater than 30'
                                                //    )
                                                //  }
                                                 return Promise.resolve()
                                               },
                                             },
                                           ]}>
                                             <div> </div>
                                           </FormItem>
                                         </>
                                         )
                                       }
                 
                                     </Control>
                 
                 
                                   </Control>
                 
                 
                                   <Control row gap="20px" top="15px">
                                     <Control width="49%" column>
                                       <FormItem name={[[level], 'degreeId']}>
                                         <div></div>
                                       </FormItem>
                                       <FormItem name={[[level], 'domainId']} />
                                       <FormItem name={[[level], 'domain']} />
                                       <LabelWithPending fieldName="degree">Degree *</LabelWithPending>
                 
                                       <AntdSelect
                                         placeholder="Eg. Bachelor of Engineering"
                                         name={[[level], 'degreeId']}
                                         rules={[
                                           {
                                             required: true,
                                             message: 'Please enter degree!',
                                           },
                                         ]}
                                         OptionData={
                                           isCurrentCourse
                                             ? completeCrudDegreeList ?? []
                                             : degreeSearchList ?? []
                                         }
                                         valueParam="id"
                                         nameParam="name"
                                         onChange={onDegreeChangeDrop}
                                         value={
                                           form.getFieldValue([[level], 'degreeId']) === 'OTHERS'
                                             ? 'Other'
                                             : form.getFieldValue([[level], 'degree'])
                                         }
                                         onSearch={data =>
                                           data?.trim()
                                             ? delayToFetchDegree(data)
                                             : delayToFetchDegree('')
                                         }
                                         onClear={() => delayToFetchDegree('')}
                                         showSearch={true}
                                         isShortName={false}
                                         filterOption={false}
                                         disabled={isCurrentCourse}
                                         onBlur={() => onBlurHandler('degree')}
                                       />
                                       {errorNote?.degree && (
                                         <RedNote>{errorNote?.degree}</RedNote>
                                       )}
                                     </Control>
                 
                                     <Control width="49%" column>
                                       <FormItem name={[[level], 'streamId']}>
                                         <div></div>
                                       </FormItem>
                                       <LabelWithPending fieldName="department">Department *</LabelWithPending>
                                       <AntdSelect
                                         placeholder="Eg. Computer Science Engineering"
                                         name={[[level], 'streamId']}
                                         rules={[
                                           {
                                             required: true,
                                             message: 'Please select department!',
                                           },
                                         ]}
                                         OptionData={
                                           isCurrentCourse
                                             ? completeCrudDepartmentList ?? []
                                             : departmentSearchList ?? []
                                         }
                                         valueParam="id"
                                         nameParam="name"
                                         onChange={onDepartmentChangeDrop}
                                         value={
                                           form.getFieldValue([[level], 'streamId']) === 'OTHERS'
                                             ? 'Other'
                                             : form.getFieldValue([[level], 'department'])
                                         }
                                         onSearch={data => delayToFetchDepartment(data)}
                                         showSearch={true}
                                         filterOption={false}
                                         disabled={isCurrentCourse}
                                         onBlur={() => onBlurHandler('department')}
                                       />
                                       {errorNote?.department && (
                                         <RedNote>{errorNote?.department}</RedNote>
                                       )}
                                     </Control>
                                   </Control>
                 
                                   <Control row gap="20px" top="15px">
                                     <Control width="49%" column>
                                      
 <LabelWithPending fieldName="specialisation">Specialisation</LabelWithPending>
                      <AntdSelect
                        placeholder="Eg. Artificial Intelligence"
                        name={[[level], 'specialisationId']}
                        valueParam="id"
                        nameParam="name"
                        rules={[
                          {
                            validator: validateSpecialisation,
                          },
                        ]}
                          OptionData={specialisationsCurrentSearchList ?? []}
                        
                          mode="multiple"
                          onChange={onSpecialisationChangeDrop}
                          value={specialisationId}
                          onSearch={data => delayToFetchSpecialisation(data)}
                          showSearch={true}
                          filterOption={false}
                        />
                                             {errorNote?.specialisation && (
                                               <RedNote>{errorNote?.specialisation}</RedNote>
                                             )}
                                     </Control>
                 
                                     <Control width="49%" column>
                                     <Control flexStart column >
                                        <Label>Current Arrears *</Label>
                                        <AntdInput
                                          width="100%"
                                          name={[[level], 'noOfArrears']}
                                          onInput={e => {
                                            e.target.value = e.target.value.replace(/[^0-9.]/g, '')
                                          }}
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                'Please enter No. Of Current Arrears / Backlogs!',
                                            },
                                            {
                                              validator: (_, value) => {
                                                if (value >= 0 && value <= 100) {
                                                  return Promise.resolve()
                                                } else {
                                                  return Promise.reject(
                                                    new Error(
                                                      'Please enter valid No. Of Arrears / Backlogs!'
                                                    )
                                                  )
                                                }
                                              },
                                            },
                                          ]}
                                        />
                 
                                      </Control>
                 
                                     </Control>
                                   </Control>
                 
                                   <Control row gap="20px" top="15px">
                                   <Control width="100%" column>
                                       <LabelWithPending fieldName="skills">Skills utilised/gained</LabelWithPending>
                                       <AntdSelect
                                         placeholder="Eg.React.js"
                                         name={[[level], 'skills']}
                                         OptionData={listOfSkills}
                                         rules={[
                                           {
                                             validator: async (_, value) => {
                                               if (value === '') {
                                                 return Promise.resolve()
                                               } else if (!Array.isArray(value)) {
                                                 form.setFieldsValue({
                                                   [level]: { skills: storeSkill },
                                                 })
                                                 return Promise.resolve()
                                               }
                 
                                               return Promise.resolve()
                                             },
                                           },
                                           {
                                             validator: validateSkill,
                                           },
                                         ]}
                                         disabled={skillLoading}
                                         valueParam="id"
                                         nameParam="name"
                                         value={selectedSkill}
                                         mode="multiple"
                                         showSearch={true}
                                         onSearch={data => delaySkillToFetch(data)}
                                         onChange={(value, id) => onSkillChange(value, id)}
                                         filterOption={false}
                                       />
                                       {skillErrorMsg && (
                                         <p style={{ color: 'red' }}>{skillErrorMsg}</p>
                                       )}
                                       {'Skills ' + selectedSkill?.length + ' / 20'}
                                     </Control>
                 
                                   </Control>
                                   <FormItem name={[[level], 'markSheetUrl']}>
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '8px',
                                      }}
                                    >
                                      <Label style={{ marginTop: '16px', color: '#9B9B9B' }}>
                                        {getMarksheetLabel(level)}
                                      </Label>

                                      {markSheetFile && (markSheetFile.url || markSheetFile.name) ? (
                                        <FileReader
                                        file={markSheetFile}
                                        onDelete={() => {
                                          setMarkSheetFile(null)
                                          form.setFieldsValue({
                                            [level]: { markSheetUrl: null },
                                          })
                                        }}
                                      />
                                      ) : (
                                        <Uploadloader
                                          variant="simple"
                                          file={markSheetFile}
                                          setFile={file => {
                                            setMarkSheetFile(file)
                                            form.setFieldsValue({
                                              [level]: { markSheetUrl: file },
                                            })
                                          }}
                                          fileName={`${studentFormData?.fullName
                                            ?.toLowerCase()
                                            ?.replace(/\s/g, '')}_marksheet`}
                                          onlyDoc={false}
                                        />
                                      )}
                                    </div>
                                  </FormItem>

                                 </>
                  </>
                ) : (
                  <>
                    <Control gap="20px">
                      <Control flexStart column>
                        <FormItem name={[[level], 'state']} />
                        <FormItem name={[[level], 'stateId']}>
                          <div> </div>
                        </FormItem>
                        <LabelWithPending fieldName="state">State *</LabelWithPending>

                        <AntdSelect
                          allowClear={true}
                          placeholder="Select"
                          name={[[level], 'stateId']}
                          rules={[
                            {
                              validator: async (_, value) => {
                                if (
                                  !form.getFieldValue([[level], 'stateId']) ||
                                  !form.getFieldValue([[level], 'stateId'])
                                ) {
                                  return Promise.reject(
                                    new Error('Please select a state!')
                                  )
                                }
                                return Promise.resolve()
                              },
                            },
                          ]}
                          OptionData={statesList}
                          notFoundContent={
                            loadingState ? (
                              <SpinWrapper center>
                                <Spin />
                              </SpinWrapper>
                            ) : (
                              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                            )
                          }
                          valueParam="name"
                          nameParam="name"
                          onChange={onStateChange}
                          value={form.getFieldValue([[level], 'state'])}
                          showSearch={true}
                          onSearch={data => delayStateToFetch(data)}
                          iskey={true}
                          filterOption={false}
                          disabled={isCurrentCourse}
                          onBlur={() => onBlurHandler('state')}
                        />
                        {!errorNote?.state && stateError != '' && (
                          <RedNote>{stateError}</RedNote>
                        )}
                        {errorNote?.state && <RedNote>{errorNote?.state}</RedNote>}
                      </Control>

                      <Control flexStart column>
                        <FormItem name={[[level], 'city']} />
                        <FormItem name={[[level], 'cityId']}>
                          <div></div>
                        </FormItem>
                        <LabelWithPending fieldName="city">City *</LabelWithPending>
                        <AntdSelect
                          allowClear={true}
                          placeholder="Select"
                          name={[[level], 'cityId']}
                          rules={[
                            {
                              validator: async (_, value) => {
                                if (
                                  !form.getFieldValue([[level], 'city']) ||
                                  !form.getFieldValue([[level], 'cityId'])
                                ) {
                                  // handleCityValidation()
                                  return Promise.reject('Please select city!')
                                }
                                return Promise.resolve()
                              },
                            },
                          ]}
                          OptionData={cityList}
                          notFoundContent={
                            loadingCity ? (
                              <SpinWrapper center>
                                <Spin />
                              </SpinWrapper>
                            ) : (
                              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                            )
                          }
                          valueParam="name"
                          nameParam="name"
                          onChange={onCityChange}
                          value={form.getFieldValue([[level], 'city'])}
                          disabled={
                            isCurrentCourse ||
                            form.getFieldValue([[level], 'state']) === '' ||
                            form.getFieldValue([[level], 'state']) === undefined
                          }
                          showSearch={true}
                          onSearch={data => delayCityToFetch(data)}
                          iskey={true}
                          filterOption={false}
                        />
                        {!errorNote?.city && cityError != '' && (
                          <RedNote>{cityError}</RedNote>
                        )}
                        {errorNote?.city && <RedNote>{errorNote?.city}</RedNote>}
                      </Control>
                    </Control>

                    <Control row gap="20px" top="15px">
                      <Control width="100%" column>
                        <LabelWithPending fieldName="collegeName">{isType ? 'School Name *' : 'College Name *'} </LabelWithPending>
                        <FormItem
                          name={[
                            [level],
                            isCurrentCourse ? 'collegeName' : 'institutionName',
                          ]}
                        >
                          <div> </div>
                        </FormItem>
                        <AntdSelect
                          placeholder="Select Institute"
                          name={[
                            [level],
                            isCurrentCourse ? 'collegeName' : 'institutionName',
                          ]}
                          nameParam="campusName"
                          valueParam="id"
                          filterOption={false}
                          showSearch={true}
                          onClear={() => delayInstituteToFetch('')}
                          OptionData={
                            loadingInstitute
                              ? []
                              : isCurrentCourse
                                ? curInstituteSearchList
                                : [
                                  ...instituteSearchList,
                                  {
                                    campusName: 'Other',
                                    id: 'OTHER',
                                    isActive: 'true',
                                  },
                                ] || []
                          }
                          notFoundContent={
                            loadingInstitute ? (
                              <SpinWrapper center>
                                <Spin />
                              </SpinWrapper>
                            ) : (
                              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                            )
                          }
                          rules={[
                            {
                              required: true,
                              message: 'Please select an institute.',
                            },
                          ]}
                          onSearch={data =>
                            data?.trim()
                              ? delayInstituteToFetch(data?.trim())
                              : delayInstituteToFetch('')
                          }
                          onChange={
                            isCurrentCourse
                              ? onInstituteChange
                              : onInstituteCampusChange
                          }
                          value={
                            form.getFieldValue([[level], 'addInstitute']) &&
                              form.getFieldValue([[level], 'institutionId']) ===
                              'OTHERS'
                              ? 'Other'
                              : form.getFieldValue([
                                [level],
                                isCurrentCourse
                                  ? 'collegeName'
                                  : 'institutionName',
                              ])
                          }
                          disabled={isCurrentCourse}
                          iscampusLocationshow={true}
                          onBlur={() =>
                            onBlurHandler(
                              isCurrentCourse ? 'collegeName' : 'institutionName'
                            )
                          }
                        />
                      </Control>

                   

                    </Control>
                    {addInstitute && (
                                  <Control top="10px"  row>
                                    <Control column width="100%"> 
                                    <Label>Please enter the Institute name *</Label>
                                    <AntdInput
                                      placeholder="Enter the Institute name"
                                      name={[
                                        [level],
                                        isCurrentCourse ? 'collegeName' : 'institutionName',
                                      ]}
                                      value={form.getFieldValue([[level], 'instituteName'])}
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Please enter the Institute name.',
                                        },
                                      ]}
                                    />
                                    </Control>  
                                  </Control>
                                )}
                    <Control row gap="20px" top="15px">
                    <Control width="100%" column>
                        <LabelWithPending fieldName="university">University </LabelWithPending>
                        <FormItem name={[[level], 'universityId']} />
                        <AntdSelect
                          allowClear
                          placeholder="Eg.University of Delhi"
                          name={[[level], 'university']}
                          onClear={() => delayUniversityToFetch('')}
                          rules={[
                            {
                              required: false,
                              message: 'Please select university!',
                            },
                          ]}
                          OptionData={universitySearchList || []}
                          valueParam="id"
                          nameParam="name"
                          showSearch={true}
                          onSearch={data =>
                            data?.trim()
                              ? delayUniversityToFetch(data?.trim())
                              : delayUniversityToFetch('')
                          }
                          onChange={onUniversityChange}
                          value={form.getFieldValue([[level], 'university'])}
                          filterOption={false}
                          onBlur={() => onBlurHandler(form.getFieldValue([[level], 'university']))}
                        />
                        {errorNote?.university && (
                          <RedNote>{errorNote?.university}</RedNote>
                        )}
                      </Control>

                      </Control>

                    <Control row gap="20px" top="15px">
                      <Control width="49%" column>
                      <FormItem   rules={[
                    {
                      required: true,
                      message: 'Please select year!',
                    },
                  ]} name={[[level], 'endedYear']}>
                      <Label> Year *</Label>
                   <Date
                    style={{ marginTop: '8px' }}
                 
                                      placeholder="Please Select the year"
                                      onChange={onDateChange}
                                      format="YYYY"
                                      picker="year"
                                      value={endedYear ? moment(endedYear) : null}
                                      inputReadOnly
                                    />
                    </FormItem>

                      </Control>

                      <Control width="49%" column>
                        <Label>
                          <span>History of Arrears</span>
                        </Label>
                        <AntdInput
                          width="100%"
                          placeholder="Enter no. History of arrears"
                          name={[[level], 'historyOfArrears']}
                          onInput={e => {
                            e.target.value = e.target.value.replace(/[^0-9.]/g, '')
                          }}
                          rules={[
                            {
                              required: false,
                              message: 'Please enter No. Of History of Arrears!',
                            },
                            {
                              validator: (_, value) => {
                                if (
                                  value === undefined ||
                                  value === null ||
                                  value === ''
                                ) {
                                  return Promise.resolve() // Resolves the promise if the field is empty
                                }
                                if (value >= 0 && value < 100) {
                                  return Promise.resolve()
                                } else {
                                  return Promise.reject(
                                    new Error(
                                      'Please enter valid No. Of History of Arrears!'
                                    )
                                  )
                                }
                              },
                            },
                          ]}
                        />
                      </Control>


                    </Control>

                    <Control row gap="20px" top="15px">
                    
                      <Control width="49%" column>
                      <LabelWithPending fieldName={markType === 'Percentage' ? 'marks' : 'cgpaValue'}>
                          <span>{markType === 'Percentage' ? `Marks (percentage) *` : `CGPA`}</span>
                        </LabelWithPending>
                        <Control>
                             
                                            <StyledInputDivRight>
                                            <AntdInput
                          width="100%"
                          placeholder={`${markType === 'Percentage' ? 'Eg. 80.00' : 'Eg. 8.00'}`}
                          name={[[level], `${markType === 'Percentage' ? 'marks' : 'cgpaValue'}`]}
                          onInput={e => {
                            e.target.value = e.target.value.replace(
                              /[^0-9.]/g,
                              ''
                            )
                          }}
                          onBlur={recalculateMarks}
                          rules={[
                            {
                              validator: (_, value) => {
                                let isValid = validateNumber(value)
                                if (!isValid) {
                                  return Promise.reject(
                                    'Please enter valid marks in Percentage!'
                                  )
                                }
                                if (value <= 30 && markType === 'Percentage') {
                                  return Promise.reject(
                                    'Percentage must be greater than 30'
                                  )
                                }
                                if (value > 10 && value > 0 && markType === 'CGPA') {
                                  return Promise.reject(
                                    'CGPA must be less than 10'
                                  )
                                }
                                return Promise.resolve()
                              },
                            },
                          ]}
                        />
                                            </StyledInputDivRight>
                                            <StyledSelectDivLeft>
                                              <AntdSelect
                                                width="100%"
                                                OptionData={markTypeList}
                                                nameParam="value"
                                                bordered={false}
                                                placeholder="Percentage"
                                                onChange={onMarkTypeChange}
                                                value={markType}
                                                allowClear={false}
                                                disabled={markType === 'Percentage' ? (frozenFields?.marks || frozenFields?.averageMarks || false) : (frozenFields?.cgpaValue || false)}
                                              />
                                            </StyledSelectDivLeft>
                      </Control>
                      </Control>

                      <Control width="49%" column>
                        {markType === "CGPA" &&
                        (<>
                         
                        <Label>
                          <span>Enter CGPA out of *</span>
                        </Label>
                          <AntdInput
                          width="100%"
                          placeholder="Percentage"
                          name={[[level], 'cgpaOutof']}
                          defaultValue="0.00"
                          onInput={e => {
                            e.target.value = e.target.value.replace(
                              /[^0-9.]/g,
                              ''
                            )
                          }}
                          onChange={recalculateMarks}
                          rules={[
                            {
                              validator: (_, value) => {
                                let isValid = validateNumber(value)
                                if (!isValid) {
                                  return Promise.reject(
                                    'Please enter valid marks in CGPA!'
                                  )
                                }
                                if (value > 10) {
                                  return Promise.reject(
                                    'CGPA must be less than 10'
                                  )
                                }  if (value < 5) {
                                  return Promise.reject(
                                    'CGPA must be greater than or Equals to 5'
                                  )
                                }
                                return Promise.resolve()
                              },
                            },
                          ]}
                        />
                          <FormItem name={[[level], 'marks']}    rules={[
                                                     {
                                                       validator: (_, value) => {
                                                         let isValid = validateNumber(value)
                                                         if (!isValid) {
                                                           return Promise.reject(
                                                             `Please enter valid marks in ${markType === 'Percentage' ? 'Percentage' : 'CGPA'}`
                                                           )
                                                         }
                                                         if (value <= 30) {
                                                           return Promise.reject(
                                                             'Percentage must be greater than 30'
                                                           )
                                                         }
                                                         return Promise.resolve()
                                                       },
                                                     },
                                                   ]}>
                          <div> </div>
                        </FormItem>
                        </>
                        )
                        }

                      </Control>


                    </Control>


                    <Control row gap="20px" top="15px">
                      <Control width="49%" column>
                        <FormItem name={[[level], 'degreeId']}>
                          <div></div>
                        </FormItem>
                        <FormItem name={[[level], 'domainId']} />
                        <FormItem name={[[level], 'domain']} />
                        <LabelWithPending fieldName="degree">Degree *</LabelWithPending>

                        <AntdSelect
                          placeholder="Eg. Bachelor of Engineering"
                          name={[[level], 'degreeId']}
                          rules={[
                            {
                              required: true,
                              message: 'Please enter degree!',
                            },
                          ]}
                          OptionData={
                            isCurrentCourse
                              ? completeCrudDegreeList ?? []
                              : degreeSearchList ?? []
                          }
                          valueParam="id"
                          nameParam="name"
                          onChange={onDegreeChangeDrop}
                          value={
                            form.getFieldValue([[level], 'degreeId']) === 'OTHERS'
                              ? 'Other'
                              : form.getFieldValue([[level], 'degree'])
                          }
                          onSearch={data =>
                            data?.trim()
                              ? delayToFetchDegree(data)
                              : delayToFetchDegree('')
                          }
                          onClear={() => delayToFetchDegree('')}
                          showSearch={true}
                          isShortName={false}
                          filterOption={false}
                          disabled={isCurrentCourse}
                          onBlur={() => onBlurHandler('degree')}
                        />
                        {errorNote?.degree && (
                          <RedNote>{errorNote?.degree}</RedNote>
                        )}
                      </Control>

                      <Control width="49%" column>
                        <FormItem name={[[level], 'streamId']}>
                          <div></div>
                        </FormItem>
                        <LabelWithPending fieldName="department">Department *</LabelWithPending>
                        <AntdSelect
                          placeholder="Eg. Computer Science Engineering"
                          name={[[level], 'streamId']}
                          rules={[
                            {
                              required: true,
                              message: 'Please select department!',
                            },
                          ]}
                          OptionData={
                            isCurrentCourse
                              ? completeCrudDepartmentList ?? []
                              : departmentSearchList ?? []
                          }
                          valueParam="id"
                          nameParam="name"
                          onChange={onDepartmentChangeDrop}
                          value={
                            form.getFieldValue([[level], 'streamId']) === 'OTHERS'
                              ? 'Other'
                              : form.getFieldValue([[level], 'department'])
                          }
                          onSearch={data => delayToFetchDepartment(data)}
                          showSearch={true}
                          filterOption={false}
                          disabled={isCurrentCourse}
                          onBlur={() => onBlurHandler('department')}
                        />
                        {errorNote?.department && (
                          <RedNote>{errorNote?.department}</RedNote>
                        )}
                      </Control>
                    </Control>

                    <Control row gap="20px" top="15px">
                      <Control width="49%" column>
                        <LabelWithPending fieldName="specialisation">Specialisation </LabelWithPending>
                                               <AntdSelect
                                               rules={[
                                                 {
                                                   validator: validateSpecialisation,
                                                 },
                                               ]}
                                                 placeholder="Eg. Artificial Intelligence"
                                                 name={[[level], 'specialisationId']}
                                                 OptionData={specialisationsSearchList ?? []}
                                                 valueParam="id"
                                                 nameParam="name"
                                                 mode="multiple"
                                                 onChange={onSpecialisationChangeDrop}
                                                 value={specialisationId}
                                                 onSearch={data => delayToFetchSpecialisation(data)}
                                                 showSearch={true}
                                                 filterOption={false}
                                               />
                        {errorNote?.specialisation && (
                          <RedNote>{errorNote?.specialisation}</RedNote>
                        )}
                      </Control>

                      <Control width="49%" column>

                      </Control>
                    </Control>

                    <Control row gap="20px" top="15px">
                      <Control width="100%" column>
                        <LabelWithPending fieldName="skills">Skills utilised/gained</LabelWithPending>
                        <AntdSelect
                          placeholder="Eg.React.js"
                          name={[[level], 'skills']}
                          OptionData={listOfSkills}
                          rules={[
                            {
                              validator: async (_, value) => {
                                if (value === '') {
                                  return Promise.resolve()
                                } else if (!Array.isArray(value)) {
                                  form.setFieldsValue({
                                    [level]: { skills: storeSkill },
                                  })
                                  return Promise.resolve()
                                }

                                return Promise.resolve()
                              },
                            },
                            {
                              validator: validateSkill,
                            },
                          ]}
                          disabled={skillLoading}
                          valueParam="id"
                          nameParam="name"
                          value={selectedSkill}
                          mode="multiple"
                          showSearch={true}
                          onSearch={data => delaySkillToFetch(data)}
                          onChange={(value, id) => onSkillChange(value, id)}
                          filterOption={false}
                        />
                        {skillErrorMsg && (
                          <p style={{ color: 'red' }}>{skillErrorMsg}</p>
                        )}
                        {'Skills ' + selectedSkill?.length + ' / 20'}
                      </Control>


                    </Control>
                    <FormItem name={[[level], 'markSheetUrl']}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px',
                          }}
                        >
                          <Label style={{ marginTop: '16px', color: '#9B9B9B' }}>
                            {getMarksheetLabel(level)}
                          </Label>

                          {markSheetFile && (markSheetFile.url || markSheetFile.name) ? (
                            <FileReader
                              file={markSheetFile}
                              onDelete={() => setMarkSheetFile(null)}
                            />
                          ) : (
                            <Uploadloader
                              variant="simple"
                              file={markSheetFile}
                              setFile={setMarkSheetFile}
                              fileName={studentFormData?.fullName
                              ?.toLowerCase()
                              ?.replace(/\s/g, '') + '_marksheet'}
                              onlyDoc={false}
                            />
                          )}
                        </div>
                      </FormItem>
                  </>
                )}

              </>
            }
          </StyledFormItem>

        </Container>
      )}
    </>
  )
}

export default EducationForm
